import { ElementProps } from '@/components/sections/builder/types';
import { ThemeColorSchemeType, ThemeProductCardType, useBuilderStore } from '@/stores/builder';
import { ElementDataType } from '@/components/sections/builder/elements/body/product-detail/type';
import InputSlider from '@/components/sections/builder/settings/input-slider';
import { shallow } from 'zustand/shallow';
import SchemeSetting from '@/components/sections/builder/settings/scheme-setting';
import { DEFAULT_THEME_PRODUCT_CARD } from '@/components/sections/builder/theme/product-card';
import InputSelect from '@/components/sections/builder/settings/input-select';
import { Separator } from '@/components/ui/separator';
import PaddingSetting from '@/components/sections/builder/settings/padding-setting';
import { Switch } from '@/components/ui/switch';

export default function ElementSetting({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setElementData: state.setElementData,
      clearSelected: state.clearSelected,
      setTheme: state.setTheme,
      theme: state.theme,
    }),
    shallow
  );

  const content = element.data as ElementDataType;
  const productCard = builder.theme.productCard || DEFAULT_THEME_PRODUCT_CARD;

  const setValueColorSchemeModa = (newValue: Partial<ThemeColorSchemeType>) => {
    builder.setTheme({
      colorSchemeModalDetail: newValue as ThemeColorSchemeType,
    });
  };

  const setValueProduct = (value: Partial<ThemeProductCardType>) => {
    builder.setTheme({
      productCard: { ...productCard, ...value },
    });
  };

  return (
    <div>
      <h1 className='text-sm font-bold '>Layout Position</h1>
      <div className='mb-3 grid grid-cols-2 items-center gap-2'>
        <h4 className=''>Desktop media posistion</h4>
        <InputSelect
          defaultValue={content.layoutPosition || 'left'}
          options={[
            { label: 'Left', value: 'left' },
            { label: 'Right', value: 'right' },
          ]}
          onChange={(v) => builder.setElementData(element.id, { layoutPosition: v })}
        />
      </div>
      <div className='mb-3 grid grid-cols-2 items-center gap-2'>
        <h4 className=''>Gallery posistion</h4>
        <InputSelect
          defaultValue={content.galleryPosition || 'horizontal'}
          options={[
            { label: 'Horizontal', value: 'horizontal' },
            { label: 'Vertical', value: 'vertical' },
          ]}
          onChange={(v) => builder.setElementData(element.id, { galleryPosition: v })}
        />
      </div>
      <Separator className='my-4' />
      <h1 className='mb-2 text-sm font-bold'>Style</h1>
      <div className='text-xs'>Color Scheme</div>
      <SchemeSetting
        value={content.colorSchemeProductDetail}
        onChange={(theme) => {
          builder.setElementData(element.id, {
            colorSchemeProductDetail: theme,
          });
          setValueColorSchemeModa(theme as ThemeColorSchemeType);
        }}
      />
      <div className='my-3 grid grid-cols-2 items-center gap-2'>
        <h4 className=''>Position button add to cart</h4>
        <InputSelect
          defaultValue={productCard?.positionButtonAddToCart || 'relative'}
          options={[
            { label: 'Relative', value: 'relative' },
            { label: 'Fixed', value: 'fixed' },
          ]}
          onChange={(val) => {
            setValueProduct({ positionButtonAddToCart: val });
          }}
        />
      </div>
      <PaddingSetting
        value={{
          top: content.topPadding || 0,
          bottom: content.bottomPadding || 0,
          left: 0,
          right: 0,
        }}
        onChange={(padding) => {
          if (padding) {
            builder.setElementData(element.id, {
              topPadding: padding.top,
              bottomPadding: padding.bottom,
            });
          }
        }}
        hideLeft={true}
        hideRight={true}
      />
      <Separator className='my-4' />
      <h1 className='text-sm font-bold '>Product Information</h1>
      <div className='mb-4 flex items-center gap-2'>
        <label>Enable swipe on mobile</label>
        <Switch
          className='ml-auto'
          checked={content.enableStickyProductDetail}
          onCheckedChange={(value) =>
            builder.setElementData(element.id, {
              enableStickyProductDetail: !!value,
            })
          }
          aria-readonly
        />
      </div>

      {content.enableStickyProductDetail && (
        <div className='mb-4 grid grid-cols-2 items-center gap-3'>
          <h4 className='text-xs'>Top image sticky</h4>
          <InputSlider
            value={content.topImage || 0}
            max={300}
            onChange={(val) =>
              builder.setElementData(element.id, {
                topImage: val,
              })
            }
          />
        </div>
      )}
    </div>
  );
}
